<template>
  <div
    class="d-flex flex-column main-wrapper"
    style="
      padding-left: 6px !important;
      padding-right: 6px !important;
      background-attachment: fixed; background-color: #000; min-height: 100vh; height: auto; background-size: cover; 
      overflow-y: scroll;
      background-color: #000; background-image: url('https://www.theking688.com/wp-content/uploads/2022/06/rm380-03-scaled.jpg');
    "
  >
    <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
      <div class="col-5 my-auto">
        <img src="https://www.theking688.com/wp-content/uploads/2024/08/cropped-THEKING688-LOGO1.png" style="width: 11rem; height: auto;" alt="">
      </div>

      <div class="col-7 p-0">
        <div class="pt-2">
          <div class="d-flex">
            <p class="mb-1" style="width: 100px; color: #FFFFFF; font-weight: 500;"> 
                        {{$t('setting.name')}}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1 text-white">: {{$store.state.authUser.name}} </p>
          </div>
          <div class="d-flex">
            <p class="mb-1" style="width: 100px; color: #FFFFFF; font-weight: 500;">
                        {{$t('setting.balance')}}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1 text-white">:
              <b>{{ Number($store.state.amount).toLocaleString() }}</b></p>
          </div>
          
          <div class="d-flex">
            <p class="mb-1" style="width: 100px; color: #FFFFFF; font-weight: 500;">
                        {{$t('setting.phone')}}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1 text-white">: {{ blurLastFiveCharacters($store.state.authUser.phone) }} </p>
          </div>
          <div class="d-flex">
            <p class="mb-1" style="width: 100px; color: #FFFFFF; font-weight: 500;">
                        {{$t('setting.withdraw')}}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1 text-white">:
              <b>{{ Number($store.state.totalWithdraw).toLocaleString() }}</b></p>
          </div>
        </div>
      </div>
  </div>

  <!-- <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
    <div class="col-12 justify-content-between my-auto d-flex flex-column py-3">
        <span class="mx-auto" style="color: #FFFFFF;">{{$t('setting.total_bonus')}}    <span class="px-3">:</span>  <span class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">{{ Number($store.state.authUser.bonus_amount).toLocaleString() }} MMK</span></span>
        <span class="text-sm px-3 text-muted pt-3"> <span style="color: #FFFFFF;">{{$t('setting.remark')}} <span class="mx-2">-</span> </span>{{$t('setting.bonus_remark')}}</span>
      </div>
  </div> -->

  <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
    <div class="col-12 justify-content-between my-auto d-flex">
        <div class="col-3 text-center pt-1" style="cursor: pointer" @click="$router.push('/deposit')">
          <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/deposit%20(4).png" style="width: 25px; height: 25px" alt="">
          <div class="mx-auto mt-1 text-sm text-nowrap" style="color: #FFFFFF; font-weight: 450;">
              {{$t('setting.deposit')}}
          </div>
        </div>
        <div class="col-3 text-center pt-1" style="cursor: pointer" @click="$router.push('/withdraw')">
          <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/withdraw%20(2).png" style="width: 25px; height: 25px" alt="">
          <div class="mx-auto mt-1 text-sm text-nowrap" style="color: #FFFFFF; font-weight: 450;">
                {{$t('setting.withdraw')}}
            </div>
        </div>
        <div class="col-3 text-center pt-1" style="cursor: pointer" @click="$router.push('/history')">
          <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/testing.png" style="width: 25px; height: 25px" alt="">
          <div class="mx-auto mt-1 text-sm text-nowrap" style="color: #FFFFFF; font-weight: 450;">
              {{$t('setting.transaction')}}
          </div>
        </div>
        <!-- <div class="col-3 text-center pt-1" style="cursor: pointer" @click="$router.push('/betslip-history')">
          <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/salmon/icons/2%20(6).png" style="width: 25px; height: 25px" alt="">
          <div class="mx-auto mt-1 text-sm text-nowrap" style="color: #FFFFFF; font-weight: 450;">
              {{$t('setting.voucher')}}
          </div>
        </div> -->
      </div>
  </div>

  <div class="px-0 col-12 pl-0 side-nav-bar-custom">
    <nav class="side-nav my-2" style="background: rgba(255, 255, 255, 0.1); border-radius: 16px;">
      <div>
        <div>
          <!-- Nav items -->
          <ul class="navbar-nav-custom">
            <li class="nav-items">
              <div class="nav-link">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/id-card%20(2).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                <span style="color: #FFFFFF;">{{$t('setting.name')}} - {{$store.state.authUser.user_name}} </span>
              </div>
            </li>
            <li
              class="nav-items"
              data-toggle="modal"
              data-target="#editUserPassword"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <!-- <i class="fas fa-key mr-3" style="color: white; font-weight: 500;"></i> -->
                  <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/reset-password%20(2).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #FFFFFF;">{{$t('setting.update_password')}}</span>
                </div>
                <div style="color: #FFFFFF;">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li>
            <li
              class="nav-items"
              @click="() => $router.push('/banking')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/king688/icons/bank%20(4).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #FFFFFF;">{{$t('setting.bank_account')}}</span>
                </div>
                <div>
                  <i style="color: #FFFFFF;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li>
            <!-- <li
              class="nav-items"
              @click="() => $router.push('/level')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/crown%20(1).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #FFFFFF;">{{$t('setting.vip_club')}}</span>
                </div>
                <div>
                  <i style="color: #FFFFFF;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li> -->
            <li
              class="nav-items"
              @click="() => $router.push('/commission')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/king688/icons/user%20(3).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #FFFFFF;">{{$t('setting.invite_friend')}}</span>
                </div>
                <div>
                  <i style="color: #FFFFFF;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li> 
            <li class="nav-items">
              <div
                class="nav-link d-flex justify-content-between"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div id="navbar-language">
                  <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/language%20(1).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #FFFFFF;">{{$t('setting.update_language')}}</span>
                </div>

                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbar-language"
                >
                  <a class="dropdown-item" @click="setLangLocalstorage('en')"
                    ><img
                      src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                      alt=""
                      class="mr-2"
                      style="width: 20px; height: 20px"
                    />
                    {{$t('en')}}</a
                  >
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="setLangLocalstorage('mm')"
                    ><img
                      src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                      alt=""
                      class="mr-2"
                      style="width: 20px; height: 20px"
                    />{{$t('mm')}}</a
                  >
                  <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="setLangLocalstorage('cn')"
                      ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("cn") }}</a
                    >
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" @click="setLangLocalstorage('th')"
                      ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("th") }}</a
                    >
                </div>

                <div style="color: #FFFFFF;">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li>
          </ul>
          
          <!-- Divider -->
          <hr class="my-3" />
          <!-- Navigation -->
          <ul class="navbar-nav-custom mb-md-3">
            <li class="nav-items">
              <div class="nav-link active active-pro" @click="logout()">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/score97/logout%20(1).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                <!-- <i class="ni ni-lock-circle-open mr-3" style="color: dark; font-weight: 500;"></i> -->
                <span style="color: #FFFFFF;">{{$t('setting.logout')}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

    <!-- ==== modal for user password edit ==== -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal- modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="card border-0 mb-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="form-group">
                  {{$t('setting.old_password')}}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.old" />
                  </div>
                  <span class="text-danger">{{ errors.old }}</span>
                </div>
                <div class="form-group">
                  {{$t('setting.new_password')}}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.new" />
                  </div>
                  <span class="text-danger">{{ errors.new }}</span>
                </div>
                <div class="form-group">
                  {{$t('setting.confirm_password')}}
                  <div class="mt-2 input-group">
                    <input class="form-control" v-model="password.confirm" />
                  </div>
                  <span class="text-danger">{{
                    errors.confirm || errors.confirmPassword
                  }}</span>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="changeNewPassword"
                  >
                    <div v-if="!isConfirm">
                      {{$t('setting.update')}}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isConfirm"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    blurLastFiveCharacters(inputString = "0000000000") {
    // Get the length of the input string
    const length = inputString.length;

    // Check if the input string has at least five characters
    if (length >= 7) {
      // Extract the first part of the string
      const firstPart = inputString.substring(length - 5, length);

      // Create a string with '*' characters for the last five numbers
      const blurredCharacters = '*'.repeat(length-5);

      // Concatenate the first part and the blurred numbers
      const blurredString = blurredCharacters + firstPart;

      return blurredString;
    } else {
      // Return the input string unchanged if it has less than five characters
      return inputString;
    }
  },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        const res = await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if(this.$route.path === '/home') {
            // this.$router.go();
          } else {
            this.$router.push('/home');
            // this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    // if(authUser && !authUser.is_verified) {
    //   this.$router.push('/auth/verify');
    // }
  },
};
</script>
<style scoped>
.css-17h40hp {
    margin: 0px;
    line-height: 1.5;
    font-size: 14px;
    font-family: NotoSansMyanmar;
    font-weight: 700 !important;
}
.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  /* background: #ff000014; */
  font-weight: bold;
}
.account-container-wrapper {
    width: auto;
    height: 200px;
    border-radius: 10px;
    color: black !important;
    /* background: #552A07; */
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
    /* background: #242424;  */
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(10px);-webkit-backdrop-filter: blur(10px);
  }
</style>
